import { render, staticRenderFns } from "./classical-admin-evaluation-summary.vue?vue&type=template&id=5a1c81ec"
import script from "./classical-admin-evaluation-summary.vue?vue&type=script&lang=js"
export * from "./classical-admin-evaluation-summary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports